

















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class PublicQuestionSignup extends Vue {
  @Prop()
  subjectUuid!: string;

  @Prop()
  isSubjective!: boolean;

  get queryRedirect() {
    let query = 'subjects/';
    query += this.subjectUuid ? this.subjectUuid : '';

    if (this.isSubjective) {
      query += '?is-subjective=true';
    }

    return query;
  }

  redirectToSignup() {
    this.$router.push({
      path: `/signup?redirect=${this.queryRedirect}`,
    });
  }
}
